import React from "react";
import Common from "../../../Common";

class UrlEditorParams extends Common {
  constructor(props) {
    super(props);
    this.state = {
      currentInput: "", // Tracks the current input value (typed by the user)
      isValid: true, // Tracks whether the input is valid
    };
  }

  getValue = () => {
    const { colDef } = this.props;
    const column = colDef?.field;

    // Return the final valid value to the grid
    return this.state.isValid ? this.state.currentInput : "";
  };

  componentDidMount() {
    const { colDef, value } = this.props;
    // Initialize the current input with the cell value from AG Grid
    this.setState({
      currentInput: value || "",
    });
  }

  isValidUrl = (url) => {
    try {
      new URL(url); // Try to create a valid URL object
      return true;
    } catch (e) {
      return false;
    }
  };

  handleChange = (evt) => {
    const { value } = evt.target;

    // Update the input as the user types
    this.setState({
      currentInput: value,
      isValid: this.isValidUrl(value), // Validate input on each change
    });
  };

  handleBlur = () => {
    const { isValid, currentInput } = this.state;

    if (isValid) {
      // If the URL is valid, inform AG Grid that editing is finished
      const { api, column, node } = this.props;
      const colDef = column.getColDef();
      api.stopEditing(true); // Stop editing and submit the value to AG Grid
    } else {
      // If the URL is invalid, revert the value to the previous valid state
      const { api, column, node } = this.props;
      api.stopEditing(false); // Don't accept the invalid value
    }
  };

  render() {
    const { colDef } = this.props;
    const { currentInput, isValid } = this.state;

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          flex: 1,
        }}
      >
        <input
          type="text"
          name={colDef?.field}
          value={currentInput}
          className={`form-control ${isValid ? "" : "is-invalid"}`}
          onChange={this.handleChange}
          onBlur={this.handleBlur} // Ensure the value is validated when the user clicks outside
        />
        {!isValid && (
          <div className="invalid-feedback">Please enter a valid URL.</div>
        )}
      </div>
    );
  }
}

export default UrlEditorParams;
